<template>
  <div
    class="item-top-actions">
    <sTooltip
      v-if="mutableOptions.number"
      :border="false"
      class="my-auto"
      :content="$t('Common.Copy')"
      :enterable="false"
      placement="bottom"
      type="white">
      <div
        class="item-top-actions_number"
        data-qa="item-number"
        @click="copyItemNumber">
        {{ itemNumber }}
      </div>
    </sTooltip>
    <ShareBlock
      class="my-auto ml-2"
      mode="icon"
      :options="{
        id: mutableOptions.id,
        number: mutableOptions.number,
        title: mutableOptions.title,
        shareLabel: mutableOptions.shareLabel,
        showParticipantsLink: mutableOptions.showParticipantsLink,
        participantsLink: mutableOptions.participantsLink,
        routeLinkOrg: mutableOptions.routeLinkOrg
      }"/>
    <slot/>
  </div>
</template>
<script>
import ShareBlock from 'components/tenders/dialogs/ShareBlock'

import { componentOptions} from 'mixins'

export default {
  name: 'ItemTopActions',
  mixins: [ componentOptions],
  data() {
    return {
      copySuccess: false,
      mutableOptions: {
        id: null,
        number: null,
        title: null,
        shareLabel: this.$t('Tenders.shareLabel'),
        routeLinkOrg: null,
        showParticipantsLink: false,
        participantsLink: null
      },
    }
  },
  methods: {
    copyItemNumber() {
      if (this.copySuccess) {
        return
      }
      navigator.clipboard.writeText(this.mutableOptions.number)
      this.copySuccess = true
      setTimeout(() => {
        this.copySuccess = false
      }, 2000)
    },
  },
  computed: {
    itemNumber() {
      if (this.copySuccess) {
        return this.$t('Common.copied')
      }
      return `#${this.mutableOptions.number || '-'}`
    },
  },
  components: {
    ShareBlock
  },
}
</script>
<style scoped lang="scss">
.item-top-actions {
  display: flex;
  justify-content: flex-end;
  &_number {
  cursor: pointer;
    &:hover,
    &:focus {
      background: rgba(50, 50, 50, 0.1);
      border-radius: 12px;
    }
  }
}
</style>
